module.exports = __webpack_public_path__ + "svg/delete-blue.svg?22b357627392ab2eb33e3eef541c9a2d";